/**
 * Debug-hjelper (kun for utvikling).
 *
 * Klikk på kartet → logger koordinat og hvilken feature du traff til
 * konsollen, og setter en markør på punktet. Brukes for å finne det
 * nøyaktige [lng, lat] til f.eks. et bygg vi vil bytte ut med en
 * 3D-modell.
 *
 * Fjernes/deaktiveres før produksjon.
 */

import { Marker } from 'maplibre-gl';

// Samle alle [lng,lat]-koordinater fra en (multi)polygon-geometri.
function collectCoords(geometry) {
  const out = [];
  const walk = (arr) => {
    if (typeof arr[0] === 'number') {
      out.push(arr);
    } else {
      arr.forEach(walk);
    }
  };
  if (geometry && geometry.coordinates) walk(geometry.coordinates);
  return out;
}

/**
 * @param {import('maplibre-gl').Map} map
 */
export function enableClickInspector(map) {
  let marker = null;

  map.on('click', (e) => {
    const lng = Number(e.lngLat.lng.toFixed(6));
    const lat = Number(e.lngLat.lat.toFixed(6));

    // Hvilke feature-lag traff vi (bygg, brygge, vei ...)?
    const features = map.queryRenderedFeatures(e.point);
    const hits = features.slice(0, 6).map((f) => ({
      layer: f.layer.id,
      sourceLayer: f.sourceLayer,
      class: f.properties?.class,
      subclass: f.properties?.subclass,
      render_height: f.properties?.render_height,
    }));

    // Tydelig, kopierbar utskrift.
    console.log(
      `%c[click] [${lng}, ${lat}]`,
      'color:#8BE93C;font-weight:bold',
      '\n  coord (kopier): [' + lng + ', ' + lat + ']',
    );
    console.table(hits);

    // Alle bygg-features på punktet (ikke bare øverste) + deres geometri-
    // struktur, slik at vi ærlig kan se om den runde tingen er en egen
    // feature eller del av det store kvartalet.
    const buildings = features.filter((f) => f.layer.id === 'buildings-3d');
    console.log(`%c[bygg] ${buildings.length} bygg-feature(s) på punktet`, 'color:#ff00d0;font-weight:bold');
    buildings.forEach((b, i) => {
      const g = b.geometry;
      const rings = collectCoords(g);
      const lngs = rings.map((c) => c[0]);
      const lats = rings.map((c) => c[1]);
      const minLng = Math.min(...lngs), maxLng = Math.max(...lngs);
      const minLat = Math.min(...lats), maxLat = Math.max(...lats);
      const wM = (maxLng - minLng) * 111320 * Math.cos((((minLat + maxLat) / 2) * Math.PI) / 180);
      const hM = (maxLat - minLat) * 111320;
      // antall polygoner/ringer for å se om det er multipolygon
      const polyCount = g.type === 'MultiPolygon' ? g.coordinates.length : 1;
      console.log(
        `  #${i} type=${g.type} polygoner=${polyCount} id=${b.id ?? '(ingen)'} ` +
          `h=${b.properties?.render_height} str=${wM.toFixed(1)}x${hM.toFixed(1)}m ` +
          `senter=[${((minLng + maxLng) / 2).toFixed(6)}, ${((minLat + maxLat) / 2).toFixed(6)}]`,
      );
    });

    // Marker punktet.
    if (marker) marker.remove();
    marker = new Marker({ color: '#c0392b' }).setLngLat([lng, lat]).addTo(map);
  });

  // Vis krysshår-cursor så det er tydelig at inspektøren er på.
  map.getCanvas().style.cursor = 'crosshair';
  console.log(
    '%c[click-inspector] aktiv – klikk på kartet for å få koordinat + feature-info',
    'color:#8BE93C',
  );
}
